import {tracking} from '@bark/bark-core';
export default function () {
    init();
}

function init() {
    if ($('.settings-page').length > 0) {
        $('#settings-enquiries-preferences-section a.profiles').on(
            'click.profiles',
            function () {
                tracking('Settings-&-enquiries', 'profiles - select', {
                    page: "settings",
                    seller_profile_id: window?.Bark?.USER?.hashed_seller_profile_id,
                });
            }
        )
        $('#settings-enquiries-preferences-section a.marketplace').on(
					'click.profiles',
					function () {
						tracking('Settings-screen', 'Enquiries settings - Select', {
							page: 'marketplace',
							seller_profile_id: window?.Bark?.USER?.hashed_seller_profile_id,
						});
					},
				);
    }
}
